import { MdOutlineChevronRight } from "react-icons/md";
import React from "react";
import { Link } from "react-router-dom";

const Pageheading = ({ pageHeading, icon, className }) => {
  return (
    <h1
      className={`flex items-center text-white  font-montserrat leading-[2.19vw] gap-x-2 md:text-[0.94vw] text-[3vw] ${className}`}
    >
      <div className=" flex items-center  opacity-100">
        <Link to="/">
          <span className="cursor-pointer">{icon}</span>
        </Link>

        <MdOutlineChevronRight size={14} />
        <span>{pageHeading}</span>
      </div>
    </h1>
  );
};

export default Pageheading;
